import { success, error as ErrorToast, warning, options, remove } from "toastr"
import configApp from "../../common/configuration"
import "toastr/build/toastr.min.css"

options = configApp.form.toastr

const showToast = (message, type, title = "") => {
  remove()
  switch (type) {
    case "error":
      ErrorToast(message, title)
      break
    case "success":
      success(message, title)
      break
    default:
      warning(message, title)
  }
}

export default showToast
